/**
Project: Voice Panel (c)
Title: Common Actions 
Description: Common actions for all components
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import { AppURLProps } from "../settings/app-urls";
import { AppConfigProps } from "../settings/app-config";
import { AppConstants } from "../settings/app-constants";
import { CLIENT_NAVIGATOR, WHITE_LIST_DOMAINS } from "../../store/constants";
import TokenUtil from "../helpers/token-util";
import axios from "axios";
import { renewIdentitySession } from "../actions/identity-actions";
import { VoiceAdminConstants } from "../../voice-admin/pages/common/settings/voice-admin-constants";

const actionFileName = "identity-actions.js";
// Manage Errors
export function manageError(err, history) {
  return new Promise(function (resolve, reject) {
    // console.error(err);
    let path = "";
    if (history.location.pathname && history.location.pathname.length > 0)
      path = path + history.location.pathname;
    if (history.location.search && history.location.search.length > 0)
      path = path + history.location.search;
    if (history.location.hash && history.location.hash.length > 0)
      path = path + history.location.hash;
    let statusCode = "";
    if (err && err.status) statusCode = err.status;
    let message = "";
    if (err && err.data && err.data.message) message = err.data.message;
    let endPoint = "";
    if (err && err.data && err.config && err.config.baseURL && err.config.url)
      endPoint = err.config.baseURL + err.config.url;
    let method = "";
    if (err && err.data && err.config && err.config.method)
      method = err.config.method;
    let errorMessage = "";
    if (err && err.data && err.data.errors && err.data.errors.length > 0)
      errorMessage = err.data.errors[0]?.message;

    logMessage("error", path, statusCode, message);
    if (
      err &&
      (err.status === AppConfigProps.httpStatusCode.notFound ||
        err.status === AppConfigProps.httpStatusCode.unauthorized)
    ) {
      // history.push(`${AppURLProps.pageNotFound}?pageURL=${path}&method=${method}&statusCode=${statusCode}&errMessage=${message}&endPoint=${endPoint}`);
      history.push({
        pathname: AppURLProps.pageNotFound,
        state: {
          pageURL: path,
          method: method,
          statusCode: statusCode,
          errMessage: errorMessage,
          endPoint: endPoint,
        },
      });
    } else if (
      err &&
      err.status === AppConfigProps.httpStatusCode.requestTimeout
    ) {
      history.push(AppURLProps.signin);
    } else {
      // history.push(
      //   `${AppURLProps.error}?pageURL=${path}&method=${method}&statusCode=${statusCode}&errMessage=${message}&endPoint=${endPoint}`
      // );
      history.push({
        pathname: AppURLProps.error,
        state: {
          pageURL: path,
          method: method,
          statusCode: statusCode,
          errMessage: errorMessage,
          endPoint: endPoint,
        },
      });
    }
  });
}

// get whitelist-domains

export function getWhitelistDomainsData(cancelToken) {
  return new Promise(async function (resolve, reject) {
    await axios
      .get(
        AppConfigProps.serverRoutePrefix + "/general/whitelist-domains",
        cancelToken
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          logMessage(
            AppConfigProps.log.severityLevel.warning,
            actionFileName + ">getWhitelistDomainsData()",
            AppConfigProps.httpStatusCode.clientClosedRequest,
            err.message
          );
        } else {
          reject(err.response);
        }
      });
  });
}

export function logMessage(type, path, statusCode, message) {
  console.log(type, path, statusCode, message);
}

// Set Client Navigator (browser) data to store
export function setClientNavigator() {
  return async function (dispatch) {
    try {
      let userAgent = navigator.userAgent;
      let accessMode = null;
      if (window.navigator.userAgent.match("Teams")) {
        // Teams Client Application
        accessMode = AppConstants.CLIENT_NAVIGATOR.ACCESS_MODE_TEAMS_CLIENT;
      } else {
        if (
          //window.location.ancestorOrigins[0] === "https://teams.microsoft.com"
          document.referrer.match("teams.microsoft")
        ) {
          // Teams in browser
          accessMode = AppConstants.CLIENT_NAVIGATOR.ACCESS_MODE_TEAMS_BROWSER;
        } else {
          // Access application in directly in browser
          accessMode = AppConstants.CLIENT_NAVIGATOR.ACCESS_MODE_REGULAR_BROWSER;
        }
      }
      const clientNavigator = {
        userAgent: userAgent,
        accessMode: accessMode,
      };
      dispatch({
        type: CLIENT_NAVIGATOR,
        payload: clientNavigator,
      });
    } catch (err) {
      throw Error(err);
    }
  };
}

export function setWhiteListDomains(domainList) {
  return async function (dispatch) {
    try {
      dispatch({
        type: WHITE_LIST_DOMAINS,
        payload: domainList,
      });
    } catch (err) {
      throw Error(err);
    }
  }
}

export function accessLogWithToken(
  pageUrl,
  pageCode = null,
  pageName = null,
  authorization = null
) {
  const data = {
    appName: AppConstants.APP_NAME,
    pageCode,
    pageName,
    pageUrl,
  };
  const headers = {
    Authorization: authorization,
  };
  axios
    .post(AppConfigProps.serverRoutePrefix + "/general/app-access-log", data, {
      headers: headers,
    })
    .catch((error) => {
      console.log(error);
    });
}

// Check User Token Expiry
export function checkIdentitySession() {
  const tokenData = TokenUtil.getIdentitySippioAccessTokenData();
  if (
    tokenData &&
    tokenData.userUUID &&
    tokenData.userDisplayName &&
    tokenData.userEmail &&
    tokenData.tokenExpiry >= Date.now() / 1000
  ) {
    return true;
  } else {
    return false;
  }
}

//check Session
export function checkIdentitySessionValid(cancelToken) {
  const tokenData = TokenUtil.getIdentitySippioAccessTokenData();
  if (
    tokenData &&
    tokenData.userUUID &&
    tokenData.userDisplayName &&
    tokenData.userEmail &&
    tokenData.tokenExpiry >= Date.now() / 1000
  ) {
    if (
      tokenData.tokenExpiry - parseInt(Date.now() / 1000) <=
      AppConfigProps.identitySession.expiryCheckRemainingSeconds
    ) {
      renewIdentitySession(cancelToken);
    }
    return true;
  } else {
    return false;
  }
}

//Get Session Expired Error Message
export function getSessionExpiredError() {
  return {
    status: AppConfigProps.httpStatusCode.requestTimeout,
    message: "Session expired please Signin again.",
  };
}

export function openConsentPopup() {
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : 500;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : 600;

  // Calculate the left and top positions
  const left = width / 2 - 500 / 2 + dualScreenLeft;
  const top = height / 2 - 600 / 2 + dualScreenTop;
  window.open(
    VoiceAdminConstants.CONSENT_LINK,
    "childWindow",
    `width=500,height=600,left=${left},top=${top}`
  );
}
